import React, { createContext, useContext, useState } from 'react'
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '~/lib/ui/pagination'
import {
  Select,
  SelectValue,
  SelectTrigger,
  SelectGroup,
  SelectContent,
  SelectItem,
} from '~/lib/ui/select'
import useTranslation from '../shared/TranslationProvider'

const PaginationContext = createContext()

export const usePagination = () => useContext(PaginationContext)

export const PaginationProvider = ({ children }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [perPage, setPerPage] = useState(10)
  const [pagination, setPagination] = useState({})
  const [filter, setFilter] = useState('future')

  const value = {
    currentPage,
    setCurrentPage,
    perPage,
    setPerPage,
    pagination,
    setPagination,
    filter,
    setFilter,
  }

  return (
    <PaginationContext.Provider value={value}>
      {children}
    </PaginationContext.Provider>
  )
}

export const FilterSelect = () => {
  const { t } = useTranslation('FilterSelect')
  const { filter, setFilter } = usePagination()

  return (
    <Select value={filter} onValueChange={setFilter}>
      <SelectTrigger className="rounded-full font-inter">
        <SelectValue placeholder="Select an Option" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectItem value="future">{t('future')}</SelectItem>
          <SelectItem value="next_week">{t('next_week')}</SelectItem>
          <SelectItem value="unscheduled">{t('unscheduled')}</SelectItem>
          <SelectItem value="all">{t('all')}</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}

export const PaginationControl = () => {
  const { setCurrentPage, pagination } = usePagination()

  const {
    page,
    next_page: nextPage,
    prev_page: prevPage,
    total_pages: totalPages,
  } = pagination

  const goToPage = (newPage) => () => {
    if (newPage == page) return
    setCurrentPage(newPage)
  }

  const pages = [...Array(totalPages).keys()]
  if (pages.length < 2) return null

  return (
    <Pagination className="mt-4 justify-start">
      <PaginationContent>
        <PaginationItem>
          {prevPage && <PaginationPrevious onClick={goToPage(prevPage)} />}
        </PaginationItem>
        {pages.map((index) => (
          <PaginationItem key={index}>
            <PaginationLink
              isActive={page == index + 1}
              className="rounded-none"
              onClick={goToPage(index + 1)}
            >
              {index + 1}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem>
          {nextPage && <PaginationNext onClick={goToPage(nextPage)} />}
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}
